import React from "react";
import { IProduct, ThemeType } from "../../../types";
import ImageSet from "../../../shared/ImageSet";
import Growth from "../../../shared/Growth";
import TableDropdown from "../../../shared/Table/TableDropdown";
import Status from "../../../shared/Status";
import Category from "../../../shared/Category";
import TableData from "../../../shared/Table/TableData";
import { useHistory } from "react-router-dom";

type ProductTableProps = {
	data: Array<Partial<IProduct>>;
	theme: ThemeType;
	filter: Array<keyof IProduct>;
};
const column = [
	"name",
	"images",
	"category",
	"owner",
	"visit",
	"growth",
	"chat",
	"status",
];
const ProductTable = ({
	theme,
	data,
	filter,
}: ProductTableProps): JSX.Element => {
	const history = useHistory();
	return (
		<div className="overflow-x-scroll">
			<table className="table-auto w-full border-none divide-y divide-gray-200 ">
				<thead className="bg-gray-50">
					<tr className="text-left bg-blue">
						{column
							?.filter((v) =>
								filter?.length > 0 ? filter?.every((val) => val !== v) : v
							)
							.map((key) => {
								return (
									<th key={key} scope="col" className="table-header">
										{key}
									</th>
								);
							})}
						<th scope="col" className="table-header">
							Actions
						</th>
					</tr>
				</thead>
				<tbody className="border-none bg-white divide-y divide-gray-200 ">
					{data
						.map((v) => {
							const neu: Partial<IProduct> = Object.entries(v)
								// Filter choosen column
								.filter(([k, v]) => {
									if (k === "_id") return k;
									return column?.length! > 0
										? column?.some((val) => val === k)
										: k;
								})
								.filter(([k, v]) => {
									return filter?.length > 0
										? filter?.every((val) => val !== k)
										: k;
								})
								.reduce((acc, [k, v]) => {
									return { ...acc, [k]: v };
								}, {});
							return neu;
						})
						.map((product, index) => {
							return (
								<tr
									key={product._id}
									className={`${
										theme === "light" ? "hover:bg-sky-50" : "hover:bg-slate-500"
									} z-10 cursor-pointer`}
									onClick={() => {
										history.push(`/dashboard/product/${product._id}/info`);
									}}
								>
									<TableData
										className="truncate text-ellipsis w-10 font-bold"
										children={product.name}
									></TableData>
									<TableData
										children={
											<div className="h-8">
												<ImageSet images={product.images || []} />
											</div>
										}
									></TableData>
									<TableData
										available={!!product.category}
										children={
											<Category
												category={product.category || "Outdoor"}
											></Category>
										}
									></TableData>
									<TableData
										children={product.owner?.displayName || ""}
									></TableData>
									<TableData
										available={!!product.visit?.toString()}
										children={product.visit || "0"}
									></TableData>
									<TableData
										available={!!product.growth?.toString()}
										children={<Growth percentage={product.growth || 0} />}
									></TableData>

									<TableData
										available={!!product.chat?.toString()}
										children={product.chat || "0"}
									></TableData>
									<TableData
										available={!!product.status}
										children={
											<Status
												status={product.status?.isVerified ? "approved" : "new"}
											/>
										}
									></TableData>
									<TableData
										children={<TableDropdown type="product" id={product._id} />}
									></TableData>
								</tr>
							);
						})}
				</tbody>
			</table>
			{!data.length && (
				<div className="text-center w-full italic text-sm py-4 text-slate-400">
					No data
				</div>
			)}
		</div>
	);
};
const defaultProps: ProductTableProps = {
	data: [],
	theme: "light",
	filter: [],
};
ProductTable.defaultProps = defaultProps;

export default ProductTable;
